import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateForbearanceCompletedLetterSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
});

export const GenerateForbearanceCompletedLetterSideEffect = GenerateForbearanceCompletedLetterSideEffectContext.extend({
  type: z.literal('generateForbearanceCompletedLetter'),
});
export type GenerateForbearanceCompletedLetterSideEffect = z.infer<typeof GenerateForbearanceCompletedLetterSideEffect>;
